import { ColorScheme } from "./types/ColorScheme";
import { useCallback, useState } from "react";

const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");


export const useTheme = () => {
  const [appearance, setAppearanceState] = useState<ColorScheme>(() => 'dark')

  const setAppearance = useCallback((state: ColorScheme) => {
    setAppearanceState(state)
    document.documentElement.setAttribute('data-color-scheme', state)
  }, [])

  const doMatchPrefers = useCallback(() => {
    if (darkThemeMq.matches) {
      setAppearance('dark')
    } else {
      setAppearance('light')
    }

    darkThemeMq.addEventListener('change', event => {
      setAppearance(event.matches ? "dark" : "light")
    })
  }, [setAppearance])

  const toggleAppearance = useCallback(() => {
    setAppearance(appearance === "dark" ? "light" : "dark")
  }, [appearance, setAppearance])


  return {
    appearance,
    setAppearance,
    doMatchPrefers,
    toggleAppearance
  }
}


